import SvgBarbell from '@sats-group/icons/24/barbell';
import SvgLocation from '@sats-group/icons/24/location';
import SvgTime from '@sats-group/icons/24/time';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import ScaleBar from '@sats-group/ui-lib/react/scale-bar';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import Breadcrumbs from '~/client/components/breadcrumbs/breadcrumbs';
import ContentContainer from '~/client/components/content-container/content-container';
import EmbedMedia from '~/client/components/embed-media/embed-media';
import GroupClasses from '~/client/components/group-classes/group-classes';
import Layout from '~/client/components/layout/layout';
import List from '~/client/components/list/list';
import RichText from '~/client/components/rich-text/rich-text';
import type { GroupExercisePage as Props } from './group-exercise-page.types';

const GroupExercisePage: React.FunctionComponent<Props> = ({
  booking,
  breadcrumbs,
  charts = [],
  duration,
  equipment,
  facility,
  layout,
  header,
  preamble,
  similarClasses,
  supplementaryClasses,
  text,
}) => (
  <Layout {...layout}>
    <Breadcrumbs {...breadcrumbs} />
    <div className="group-exercise-page">
      <ContentContainer>
        <div className="page-header__media">
          {header.media ? (
            <EmbedMedia
              theme={EmbedMedia.themes.paddedButtons}
              {...header.media}
            />
          ) : null}
        </div>

        <div className="group-exercise-page__main">
          <div className="group-exercise-page__metadata">
            {duration ? (
              <div className="group-exercise-page__metadata-item">
                <SvgTime />
                <Text>{duration}</Text>
              </div>
            ) : null}
            {facility ? (
              <div className="group-exercise-page__metadata-item">
                <SvgLocation />
                <Text>{facility}</Text>
              </div>
            ) : null}
            {equipment ? (
              <div className="group-exercise-page__metadata-item">
                <SvgBarbell />
                <Text>{equipment}</Text>
              </div>
            ) : null}
            <LinkButton
              {...booking}
              wide={true}
              size={LinkButton.sizes.basic}
            />
          </div>
          <div className="group-exercise-page__content">
            <Text
              elementName="h1"
              size={Text.sizes.headline2}
              theme={Text.themes.headline}
              italic
              className="group-exercise-page__heading"
            >
              {header.title}
            </Text>
            {preamble ? (
              <p className="group-exercise-page__preamble">{preamble}</p>
            ) : null}
            {text ? (
              <div className="group-exercise-page__text">
                <RichText {...text} />
              </div>
            ) : null}
          </div>
        </div>

        {charts.length ? (
          <div className="group-exercise-page__charts">
            <List theme={List.themes.gridLarge}>
              {charts.map(({ label, chart }) => (
                <div className="group-exercise-page__chart" key={label}>
                  <Text
                    className="group-exercise-page__chart-label"
                    elementName="div"
                  >
                    {label}
                  </Text>
                  <ScaleBar {...chart} />
                </div>
              ))}
            </List>
          </div>
        ) : null}

        {supplementaryClasses ? (
          <div className="group-exercise-page__related-classes">
            <GroupClasses {...supplementaryClasses} />
          </div>
        ) : null}

        {similarClasses ? (
          <div className="group-exercise-page__related-classes">
            <GroupClasses {...similarClasses} />
          </div>
        ) : null}
      </ContentContainer>
    </div>
  </Layout>
);

export default GroupExercisePage;
